module.exports = __webpack_public_path__ + "img/MERGENXXX.d63d4bf3.png";